module.exports = __webpack_public_path__ + "static/media/CompleteCompliance.4e240037.svg";